import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Pencil — slanted writing instrument with a tip + an eraser/ferrule
 *  end. Used as the "edit this row in place" affordance across the
 *  reader's annotation rail and any future inline-edit surfaces.
 *  Smaller than `IcnQuill` so it reads as a chip-row glyph rather
 *  than a hero ornament. */
export function IcnPencil(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="pencil">
      <path d="M11 2.5 13.5 5 5 13.5l-3 .5.5-3z" />
      <path d="M10 3.5 12.5 6" />
    </Svg>
  );
}
